import { TFunction } from "react-i18next";
import * as yup from "yup";

import { SecondStepHandle } from ".";

export const validateSecondStep = (
  translate: TFunction<"translate", undefined>,
  validationObject: SecondStepHandle,
  callback: (error: yup.ValidationError[]) => void
) => {
  try {
    const schema = yup.object().shape({
      companyName: yup.string().required(translate("thisFieldIsRequired")),
      companyType: yup.string().required(translate("thisFieldIsRequired")),
    });

    schema.validateSync(
      validationObject,
      { abortEarly: false }
    );
    callback([]);

    return true;
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      callback(err.inner);
    }

    return false;
  }
};
